import * as React from 'react';

import FileBoxNote32 from './FileBoxNote32';

export const fileBoxNote32 = () => <FileBoxNote32 />;

export default {
    title: 'Icon/Content/FileBoxNote32',
    component: FileBoxNote32,
    parameters: {
        notes: "`import FileBoxNote32 from 'box-ui-elements/es/icon/content/FileBoxNote32';`",
    },
};
